import { lazy, Suspense } from "react";

const InviteAllParentsAnimation = lazy(
  () =>
    import(
      /* webpackChunkName: "invite-classes-parents-animation" */ "./InviteClassesParentsAnimation"
    )
);

export default function InviteClassesParentsModalSuccess({
  onComplete
}: {
  onComplete?: () => void;
}) {
  return (
    <Suspense fallback={null}>
      <InviteAllParentsAnimation onComplete={onComplete} />
    </Suspense>
  );
}
